import { startEmbeddedAuth, getEmbeddedToken, onEmbeddedToken } from "./embeddedAuth";

const decode = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return {};
  }
};

export async function initEmbeddedKeycloak(keycloak) {
  await startEmbeddedAuth(); // waits for the first token from the host

  // No login redirect and no Keycloak iframes inside the iframe
  await keycloak.init({ checkLoginIframe: false }).catch((err) => console.warn("keycloak init:", err));

  const apply = (token) => {
    const p = decode(token);
    keycloak.token = token;
    keycloak.tokenParsed = p;
    keycloak.subject = p.sub;
    keycloak.realmAccess = p.realm_access;
    keycloak.resourceAccess = p.resource_access;
    keycloak.authenticated = true;
  };

  apply(await getEmbeddedToken());
  onEmbeddedToken(apply); // the host pushes fresh tokens before expiry

  // Anything that refreshes the token asks the host instead of Keycloak
  keycloak.updateToken = async () => {
    apply(await getEmbeddedToken());
    return true;
  };

  // A login redirect inside the iframe would be blocked by Keycloak anyway
  keycloak.login = async () => console.warn("login() ignored: running embedded");
}